var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { makeStyles, Tooltip } from '@material-ui/core';
import { startCase, upperFirst } from 'lodash';
import React, { useState } from 'react';
import { heading } from '../Styles/Colours';
import { ApprovedIndicationsDialog } from './ApprovedIndicationsDialog';
import styles from './MedicationBrowserPacksDetail.module.css';
var useStyles = makeStyles({
    prescriberGroupItem: function (props) {
        var _a, _b, _c, _d, _e;
        var borderColor = heading;
        if (((_a = props.displayShortName) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DP') {
            borderColor = '#FFAD72';
        }
        else if (((_b = props.displayShortName) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'MP') {
            borderColor = '#FF0000';
        }
        else if (((_c = props.displayShortName) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'MW') {
            borderColor = '#0066FF';
        }
        else if (((_d = props.displayShortName) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === 'NP') {
            borderColor = '#00A897';
        }
        else if (((_e = props.displayShortName) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === 'OP') {
            borderColor = '#BC6DEC';
        }
        return {
            border: '1px solid',
            borderColor: borderColor,
            borderRadius: '50%',
            marginRight: '8px',
            marginBottom: '8px',
            width: '26px',
            height: '26px',
            maxWidth: '26px',
            maxHeight: '26px',
            lineHeight: '24px',
            textAlign: 'center',
            fontSize: '11px',
            fontWeight: 600
        };
    }
});
function PrescriberGroupIcon(props) {
    var _a;
    var group = props.group;
    var styles = useStyles(group);
    return (React.createElement(Tooltip, { id: "tooltip-" + group.code, title: group.name, placement: 'bottom' },
        React.createElement("span", { className: styles.prescriberGroupItem }, (_a = group.displayShortName) !== null && _a !== void 0 ? _a : group.code)));
}
export var PrescriberGroups = function (props) {
    return (React.createElement("div", { className: styles.prescriberGroups }, props.row.supportedPaymentArrangement.prescriberGroups.map(function (group, index) {
        return React.createElement(PrescriberGroupIcon, { group: group, key: group.code + "-" + index });
    })));
};
export var MedicationBrowserPacksDetail = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var indicationsVisible = ((_b = (_a = props.row.approvedIndications) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
    var pbsScheduleVisible = !!props.row.supportedPaymentArrangement.pbsDetail;
    var pbsDetailCode = (_d = (_c = props.row.supportedPaymentArrangement) === null || _c === void 0 ? void 0 : _c.pbsDetail) === null || _d === void 0 ? void 0 : _d.code;
    var _g = __read(useState(false), 2), showIndicationDialog = _g[0], setShowIndicationDialog = _g[1];
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.blueLine }),
        React.createElement("div", { className: styles.cellItem },
            React.createElement("div", { className: styles.fieldText }, "Full medication name"),
            React.createElement("div", null, props.row.name)),
        React.createElement("div", { className: styles.cellItem },
            React.createElement("div", { className: styles.fieldText }, "Generic name"),
            React.createElement("div", null, (_f = (_e = props.row.medicinalProduct) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : 'Unknown')),
        React.createElement("div", { className: styles.greyLine }),
        !pbsScheduleVisible && (React.createElement("div", { className: styles.pbsSchedule },
            React.createElement("div", { className: styles.fieldText }, "PBS Schedule"),
            React.createElement("div", null, "None"))),
        pbsScheduleVisible && (React.createElement("div", { className: styles.pbsSchedule },
            React.createElement("div", { className: styles.fieldText }, "PBS Schedule"),
            React.createElement("div", null, props.row.supportedPaymentArrangement.pbsProgramName),
            React.createElement("div", null, '(' + startCase(props.row.supportedPaymentArrangement.restrictionType) + ')'))),
        indicationsVisible && (React.createElement("div", { className: styles.cellItem },
            React.createElement("div", { className: styles.fieldText }, "Approved indications"),
            props.row.approvedIndications.map(function (indication, index) {
                var _a;
                var name = indication.approvedIndicationName ? indication.approvedIndicationName : '';
                var indicationNumber = indication.approvedIndicationNumber
                    ? '#' + indication.approvedIndicationNumber
                    : '';
                var treatmentPhase = (_a = indication.treatmentPhase) !== null && _a !== void 0 ? _a : '';
                if (treatmentPhase === '') {
                    return React.createElement("div", { className: styles.indication, key: index }, indicationNumber + " " + name);
                }
                return (React.createElement("div", { key: index },
                    React.createElement("div", { className: styles.indication }, indicationNumber + " " + name),
                    React.createElement("div", { className: styles.treatment }, "Treatment Phase: " + treatmentPhase)));
            }))),
        !indicationsVisible && React.createElement("div", null),
        React.createElement("div", { className: styles.cellItem },
            React.createElement("div", { className: styles.fieldText }, "Active ingredients"),
            props.row.activeIngredients.map(function (ingredient, index) {
                var _a, _b, _c, _d, _e, _f;
                var name = ((_a = ingredient.substance) === null || _a === void 0 ? void 0 : _a.name) ? upperFirst(ingredient.substance.name) : '';
                var strength = (_c = (_b = ingredient.unitOfUse) === null || _b === void 0 ? void 0 : _b.strength) !== null && _c !== void 0 ? _c : '';
                var unit = (_f = (_e = (_d = ingredient.unitOfUse) === null || _d === void 0 ? void 0 : _d.strengthUnit) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : '';
                var nameSeparator = !!name && !!strength && !!unit ? ' - ' : '';
                var strengthSeparator = !!strength && !!unit ? ' ' : '';
                return React.createElement("div", { key: index }, "" + name + nameSeparator + strength + strengthSeparator + unit);
            })),
        indicationsVisible && (React.createElement("div", { className: styles.readMore },
            React.createElement("a", { className: styles.readMoreLink, onClick: function () { return setShowIndicationDialog(true); } }, "Read more"))),
        indicationsVisible && showIndicationDialog && pbsDetailCode && (React.createElement(ApprovedIndicationsDialog, { pbsDetailCode: pbsDetailCode, onClose: function () { return setShowIndicationDialog(false); } }))));
};
